module.exports = __webpack_public_path__ + "static/media/pencil.9d1c04ed.svg";